import EducationTab from "./EducationTab";
export default EducationTab;
